<ng-template #NewEventMessage>{{'COMPONENTS.MANAGE-EVENT-SALE-CATEGORY-STATES.NEW-EVENT-MESSAGE' | translate}}</ng-template>

@if (tenantShopList.length > 1) {
  <div class="py-3 d-flex flex-row">
    @for (tenantShop of tenantShopList; track tenantShop) {
      <div class="d-flex ms-2" (click)="setActive(tenantShop.Id)">
        <button class="m-0 btn btn-small" [class.btn-primary]="activeTenantShop.Id == tenantShop.Id">{{tenantShop.Name}}</button>
      </div>
    }
  </div>
}

<t4-tabs (selected)="onTabChange($event)">
  @for (saleCategory of eventSaleCategories; track saleCategory) {
    <t4-tab [tabTitle]="saleCategory.Name" [id]="saleCategory.Id.toString()"></t4-tab>
  }
</t4-tabs>

<div>
  <app-custom-button-state-list  #customButtonStateListComponent></app-custom-button-state-list>
</div>




